import script from "./HappyCallHistModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HappyCallHistModal.vue?vue&type=script&setup=true&lang=js"

import "./HappyCallHistModal.vue?vue&type=style&index=0&id=147f7a50&lang=scss"

const __exports__ = script;

export default __exports__